import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bd4a06e4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "tabs-bar-container",
  class: "tabs-bar-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "cursor": "pointer"
  }
}, [/*#__PURE__*/_createTextVNode(" 更多操作"), /*#__PURE__*/_createElementVNode("em", {
  class: "el-icon-arrow-down el-icon--right"
})], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_remix_icon = _resolveComponent("remix-icon");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, {
    modelValue: $data.tabActive,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.tabActive = $event),
    type: "card",
    class: "tabs-content",
    onTabClick: $options.handleTabClick,
    onTabRemove: $options.handleTabRemove
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visitedRoutes, item => {
      return _openBlock(), _createBlock(_component_el_tab_pane, {
        key: item.path,
        label: item.meta.title,
        name: item.path,
        closable: !$options.isAffixed(item)
      }, null, 8, ["label", "name", "closable"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onTabClick", "onTabRemove"]), _createVNode(_component_el_dropdown, {
    onCommand: $options.handleCommand,
    placement: "bottom-end"
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
      class: "tabs-more"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
        command: "refreshRoute"
      }, {
        default: _withCtx(() => [_createVNode(_component_remix_icon, {
          icon: "fas fa-circle-notch",
          class: "el-dropdown-menu__item-icon"
        }), _createTextVNode(" 刷新 ")]),
        _: 1
      }), _createVNode(_component_el_dropdown_item, {
        command: "closeOthersTabs"
      }, {
        default: _withCtx(() => [_createVNode(_component_remix_icon, {
          icon: "fas fa-times-circle",
          class: "el-dropdown-menu__item-icon"
        }), _createTextVNode(" 关闭其他 ")]),
        _: 1
      }), _createVNode(_component_el_dropdown_item, {
        command: "closeLeftTabs"
      }, {
        default: _withCtx(() => [_createVNode(_component_remix_icon, {
          icon: "fas fa-arrow-alt-circle-left",
          class: "el-dropdown-menu__item-icon"
        }), _createTextVNode(" 关闭左侧 ")]),
        _: 1
      }), _createVNode(_component_el_dropdown_item, {
        command: "closeRightTabs"
      }, {
        default: _withCtx(() => [_createVNode(_component_remix_icon, {
          icon: "fas fa-arrow-alt-circle-right",
          class: "el-dropdown-menu__item-icon"
        }), _createTextVNode(" 关闭右侧 ")]),
        _: 1
      }), _createVNode(_component_el_dropdown_item, {
        command: "closeAllTabs"
      }, {
        default: _withCtx(() => [_createVNode(_component_remix_icon, {
          icon: "fas fa-ban",
          class: "el-dropdown-menu__item-icon"
        }), _createTextVNode(" 关闭全部 ")]),
        _: 1
      })]),
      _: 1
    })]),
    default: _withCtx(() => [_hoisted_2]),
    _: 1
  }, 8, ["onCommand"])]);
}